// https://docs.fineuploader.com/tag/3.8.2/features/handling-errors.html
export default {
    'it-IT': {
        nicknameNonPuoContenereCampiInvalidi: 'Nickname con caratteri non validi. Caratteri ammessi: alfanumerici - .' ,
        nicknameEsisteGia: 'Il nickname selezionato esiste già. Si prega di inserirne un altro'
    },
    'fr-FR': {
        nicknameNonPuoContenereCampiInvalidi: 'Pseudonyme avec des caractères non valides. Caractères acceptés : alphanumériques - .',
        nicknameEsisteGia: 'Le nom indiqué existe déjà. Veuillez en choisir un autre'
    },
    'es-ES': {
        nicknameNonPuoContenereCampiInvalidi: 'Nickname con caracteres no válidos. Caracteres permitidos: alfanuméricos - .',
        nicknameEsisteGia: 'El nombre de usuario ya existe. Por favor, elija otro.'
    },
    'en-GB': {
        nicknameNonPuoContenereCampiInvalidi: 'Nickname with invalid characters. Characters allowed: alphanumeric - .',
        nicknameEsisteGia: 'The nickname selected already exists. Please choose another one'
    },
    'en-US': {
        nicknameNonPuoContenereCampiInvalidi: 'Nickname with invalid characters. Characters allowed: alphanumeric - .',
        nicknameEsisteGia: 'The nickname selected already exists. Please choose another one'
    },
    'de-DE': {
        nicknameNonPuoContenereCampiInvalidi: 'Nickname mit ungültigen Zeichen. Akzeptierte Zeichen: alphanumerische - .',
        nicknameEsisteGia: 'Der ausgewählte Nickname existiert bereits. Geben Sie bitte einen anderen ein'
    },
    'en-AU': {
        nicknameNonPuoContenereCampiInvalidi: 'Nickname with invalid characters. Characters allowed: alphanumeric - .',
        nicknameEsisteGia: 'The nickname selected already exists. Please choose another one'
    },
    'ko-KR': {
        nicknameNonPuoContenereCampiInvalidi: '닉네임에 사용 불가한 문자가 포함되었습니다. 사용 가능한 문자는 영문 대/소문자, 숫자만 사용 가능합니다.',
        nicknameEsisteGia: '선택하신 닉네임이 이미 사용 중 입니다 다른 이름을 선택하십시오'
    }
}